import React, { ReactNode, useContext, useEffect, useMemo } from 'react';
import { AddCampaignButton, EditCampaignModal } from "./CampaignForm";
import { Bot } from '../bot-loaders';
import { CampaignContext, CampaignStore } from './campaign-context';
import { Campaign, campaingStatusDescription, checkCampaignInteraction, listCampaigns } from '../campaign-api';
import { ClickShield, Column, Table } from '../table/Table';
import { formatDatetime } from 'simple-utils/dist/date-utils';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { MemberListPreview } from './member-table';
import { SendMessageModalButton } from './send-message-modal';
import { Loading } from '../components/Loading';
import { useConfirm } from '../components/Dialogs';

function CBot({bot}:{bot:Bot}):JSX.Element{
    const {dispatch} = useContext(CampaignContext);
    useEffect(()=>{
        dispatch({type:"setBot", bot})
    }, [bot])

    return null;
}

function CampaignList(){
    const {state:{campaigns, bot}, dispatch} = useContext(CampaignContext);
    const navigate = useNavigate()

    useEffect(function(){
        if(bot == null) return;
        (async () => {
            try{
                const result = await listCampaigns(bot)
                dispatch({type:"setCampaigns", list: result});
            }catch(e){
                console.error(e);
            }
        })()
    }, [bot])

    const columns = useMemo(():Column<Campaign>[] =>{
        return [
            {id:"name", label:"Campanha", render: (c) => c.name},
            {id:"audience", label:"Público", render: (c) => c.audienceName},
            {id:"created", label:"Criação", render: (c) => formatDatetime(c.created)},
            {id:"status", label:"Status", render: (c) => campaingStatusDescription(c.status)},
            {id:"actions", label:"", render: (c) => <ClickShield><button className='btn btn-primary' onClick={() => dispatch({type:"setEditCampaign", campaign: c})}><i className='fa fa-edit'></i></button></ClickShield>}
        ]
    }, [])

    if(campaigns == null) return <Loading />
    if(campaigns.length == 0) return <>Não há campanhas para este bot.</>

    function onClick(campaign:Campaign){
        dispatch({type:'setMembers', members:null})
        navigate('./' + campaign.id);
    }

    return <>
        <div className='mb-2'>Listando {campaigns.length} campanhas</div>
        <div className='table-view'>
            <Table columns={columns} data={campaigns} onClick={onClick} />
        </div>
    </>
}

function Index(){
    return <>
        <CampaignList />
        <AddCampaignButton />
        <EditCampaignModal />
    </>
}

function CampaignPage(){
    const {campaignId} = useParams();
    const {state:{campaigns, viewCampaign}, dispatch} = useContext(CampaignContext)

    useEffect(() =>{
        const id = parseInt(campaignId);
        const campaign = campaigns.find(c => c.id == id);
        dispatch({type:"setViewCampaign", campaign})
    }, [campaignId])

    if(viewCampaign?.id != parseInt(campaignId)) return <></>

    return <>
        <div className='mb-4'>{viewCampaign.name}</div>
        <MemberListPreview />
        
    </>
}

export function CampaignIndex({bot}:{bot:Bot}){
    return <CampaignStore>
            <CBot bot={bot} />
            <div className="mt-4">
                <Routes>
                    <Route path='/' element={<Index />} />
                    <Route path='/:campaignId/' element={<CampaignPage />} />
                </Routes>     
            </div>
    </CampaignStore>
}